import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import certificate from '../../../assets/images/certificate.jpeg';
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FiDownload } from "react-icons/fi";
import { baseUrl } from "../../../api/common";
import axios from "axios";
import { convertCertificateDate } from "../common";

const UserMembershipCertificateForMobile = () => {
  
  const { slug } = useParams();
  const certificateRef = useRef(null);
  const [memberDetails, setMemberDetails] = useState({});
  const [certificateDetails, setCertificateDetails] = useState({});

  const fetchMemberDetailsData = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/member_detail`,
        { id: slug },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        const data = response.data.data[0];
        setMemberDetails(data);
        handleMembershipCertificateClick(data.member_reg_date);        
        console.log(response.data, "fetchMemberDetailsData");
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const handleMembershipCertificateClick = async (applicationDate) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/certificate_data_list`,
        { member_apply_date: applicationDate },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        setCertificateDetails(response.data.data[0]);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const handleDownloadPDF = () => {
    if (!certificateRef.current) return;

    html2canvas(certificateRef.current, {
      scale: 2,
      logging: false,
      useCORS: true,
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
      });

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = 0;

      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
      pdf.save(
        `${memberDetails.first_name}-${memberDetails.membership_no}.pdf`
      );
    });
  };

  // Fetch data only once on component mount
  useEffect(() => {
    fetchMemberDetailsData();
  }, []);

  // Trigger auto-download on mobile when data is ready
  useEffect(() => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    // if (isMobile && Object.keys(memberDetails).length > 0 && Object.keys(certificateDetails).length > 0) {
    if (Object.keys(memberDetails).length > 0 && Object.keys(certificateDetails).length > 0) {
      handleDownloadPDF();
    }
  }, [memberDetails, certificateDetails]);

  return (
    <>
      <style>
        {`
          .lino_font {
              font-family: 'Linotext', serif;
          }
          .fs_15 {
              font-size: 15px;
          }
          .certificate-container {
              width: 794px;
              height: 1123px;
              margin: auto;
              position: relative;
              text-align: center;
              padding: 9pc 7pc 8pc 6pc;
              background: white;
              background-image: url(${certificate});
              background-size: 100% 100%;
              background-position: center;
              background-repeat: no-repeat;
          }
          .certificate-header img {
              width: 100px;
              margin-bottom: 20px;
          }
          .certificate-title {
              color: red;
          }
          .certificate-content {
              margin: 15px 0;             
              font-size: 16px;
          }
          .mt-40 {
            margin-top: 40px;
          }
          .mt-30 {
            margin-top: 30px;
          }
          .mb-30 {
            margin-bottom: 30px;
          }
          .certificate-name {
              font-weight: bold;
              font-size: 25px;
          }
          .details-section {
              display: flex;
              justify-content: space-between;
          }
          .signature-section {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-top: 40px;
          }
          .signature-box {
              text-align: center;
          }
          .signature-box img {
              width: 120px;
          }
          .seal-logo img {
              width: 120px;
          }
        `}
      </style>
      <div ref={certificateRef} className="certificate-container">
        {certificateDetails && certificateDetails.top_logo && (
        <div className="certificate-header">
          <img src={`${baseUrl}/${certificateDetails.top_logo}`} alt="AMASI Logo" />
        </div>)}

        <h2 className="lino_font certificate-title mt-4">
          Association of Minimal Access Surgeons of India
        </h2>

        <p className="certificate-content mt-40">
          The President <br /> and <br /> The Executive Committee <br />
          In recognition of the Qualifications and <br />
          Dedication to the Practice of <br />
          Art & Science of Minimal Access Surgery <br />
          hereby Admit
        </p>

        <h3 className="certificate-name mt-30 mb-30">
          Dr. {memberDetails.first_name ? memberDetails.first_name : ""}
              {memberDetails.middle_name ? " " + memberDetails.middle_name : ""}
              {memberDetails.last_name ? " " + memberDetails.last_name : ""}
        </h3>

        <p className="certificate-content">
          As an {memberDetails.application_name} <br />
          Association of Minimal Access Surgeons of India
        </p>

        <div className="details-section mt-40">
          <p className="fs_15">Membership No: {memberDetails.membership_no}</p>
          {new Date(convertCertificateDate(memberDetails.member_reg_date)) > new Date("2015-12-31") && (
              <p className="fs_15">Date: {convertCertificateDate(memberDetails.member_reg_date)}</p>
          )}
          {/* <p className="fs_15">Date: {convertCertificateDate(memberDetails.member_reg_date)}</p> */}
        </div>

        <div className="signature-section">
          {certificateDetails && certificateDetails.president_sign && certificateDetails.president_name && (
          <div className="signature-box">
            <img src={`${baseUrl}/${certificateDetails.president_sign}`} alt="President Sign" />
            <p>{certificateDetails.president_name}</p>
            <p>President</p>
          </div>)}
         {certificateDetails && certificateDetails.bottom_logo && (
          <div className="seal-logo">
            <img src={`${baseUrl}/${certificateDetails.bottom_logo}`} alt="AMASI Seal" />
          </div>)}
        {certificateDetails && certificateDetails.secretary_sign && certificateDetails.secretary_name && (
          <div className="signature-box">
            <img src={`${baseUrl}/${certificateDetails.secretary_sign}`} alt="Secretary Sign" />
            <p>{certificateDetails.secretary_name}</p>
            <p>Secretary</p>
          </div>)}
        </div>
      </div>
    </>
  );
};

export default UserMembershipCertificateForMobile;